export const GENERAL_ERROR_VIEW_PROPS = {
  shortNotice: 'Es ist ein Fehler aufgetreten. Das tut uns Leid.',
  reloadLabel: 'Seite neu laden',
}
